// Querys and Mutations
import {
    ALL_ACTIVE,
    GET_WITH_PAGINATION,
    CREATE,
    UPDATE,
    DELETE
} from '@/graphql/config/ReasonForTerminationWorkGraphql'

// models
import { Paginator, ResponseDefault } from '@/models'
import {
    ReasonForTerminationWorkModel,
    ReasonForTerminationWorkForm,
    ReasonForTerminationWorkWithPagination
} from '@/models/config'

// apollo
import { apolloClient } from '@/apollo'

class ReasonForTerminationWorkService {
    async getActivated (): Promise<ReasonForTerminationWorkModel[]> {
        const result = await apolloClient.query({
            query: ALL_ACTIVE
        })
        return result.data.reasonForTerminationWorkActive
    }

    async getWithPagination (perPage = 10, page = 1): Promise<ReasonForTerminationWorkWithPagination> {
        const result = await apolloClient.query({
            query: GET_WITH_PAGINATION,
            variables: {
                page: page,
                perPage: perPage
            }
        })
        const pagination: Paginator = result.data.reasonForTerminationWorkWithPagination.paginatorInfo
        const data: ReasonForTerminationWorkModel[] = result.data.reasonForTerminationWorkWithPagination.data
        const response: ReasonForTerminationWorkWithPagination = {
            objects: data,
            pagination: pagination
        }
        return response
    }

    /**
     * Mutations
     */
     async create (form: ReasonForTerminationWorkForm): Promise<ReasonForTerminationWorkModel> {
        const result = await apolloClient.mutate({
            mutation: CREATE,
            variables: {
                input: form
            }
        })
        return result.data.createWorkShift
    }

    async update (id: number, form: ReasonForTerminationWorkForm): Promise<ReasonForTerminationWorkModel> {
        const result = await apolloClient.mutate({
            mutation: UPDATE,
            variables: {
                id: id,
                input: form
            }
        })
        return result.data.updateWorkShift
    }

    async delete (id: number): Promise<ResponseDefault> {
        await apolloClient.mutate({
            mutation: DELETE,
            variables: {
                id: id
            }
        })
        return {
            success: true,
            errors: []
        }
    }
}

export default new ReasonForTerminationWorkService()
